import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  role: "status",
  class: "stretchy-dot-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _cache[0] || (_cache[0] = _createStaticVNode("<div class=\"relative\"><div class=\"stretchy-dot\"></div><div class=\"stretchy-dot\"></div><div class=\"stretchy-dot\"></div><div class=\"stretchy-dot\"></div></div>", 1)),
    _createElementVNode("span", {
      class: _normalizeClass(["text", { 'sr-only' : !_ctx.showText }]),
      role: "alert",
      "aria-busy": "true",
      "aria-live": "polite"
    }, _toDisplayString(_ctx.dotsText), 3)
  ]))
}